import { useState, useEffect } from "react";
import { SAVE_PROPERTY } from "../api/constants";
import SaveButton from '../assets/images/save.svg';

const SavePropertyButton = ({ property }) => {
    const [isSaved, setIsSaved] = useState(property.is_saved || false);

    useEffect(() => {
        setIsSaved(property.is_saved || false);
    }, [property]);

    const token = localStorage.getItem("token");

    const toggleSave = async () => {
        if (!token) {
            //alert("You must be logged in to save properties");
            return;
        }

        try {
            const response = await fetch(SAVE_PROPERTY, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ property_id: property.id }),
            });

            const data = await response.json();

            if (data.message === "Saved") {
                setIsSaved(true);
            }
            else {
                setIsSaved(false);
            }
        } catch (err) {
            console.error("Error saving property:", err);
        }
    };

    if (!token) return null;

    return (
        <button
            className={`custom-bttn fhs-button ${isSaved ? "active" : ""}`}
            onClick={toggleSave}
        >
            <img src={SaveButton} alt="Save" /> Save
        </button>
    );
};

export default SavePropertyButton;
